import { PublicClientApplication } from '@azure/msal-browser';

const getEnv = (key) => window._env_?.[key] ?? process.env[key];

export const agenticMsalInstance = new PublicClientApplication({
  auth: {
    clientId: getEnv('REACT_APP_AGENTIC_MSAL_CLIENT_ID') || '00000000-0000-0000-0000-000000000000',
    authority: getEnv('REACT_APP_AGENTIC_MSAL_AUTHORITY') || 'https://login.microsoftonline.com/common',
    redirectUri: getEnv('REACT_APP_AGENTIC_MSAL_REDIRECT_URI') || window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
});

export const agenticLoginRequest = {
  scopes: ['User.Read'],
  redirectUri: window.location.origin + '/apps',
};
